import { useContext } from 'react';

import { SceneContext } from '@/components/app/scenes/SceneProvider';

export const useScenes = () => useContext(SceneContext);
